module.exports = __webpack_public_path__ + "img/img44.c4d7f79f.svg";